import { c as _c } from "react/compiler-runtime";
/**
 * Stand-in for the actions slot on protected routes, where every visitor is
 * signed in because the proxy sends anyone else to `/auth`. `SignedOutActions`
 * is the fallback everywhere else, but here it would prerender "Sign in" and
 * "Get started" into a dashboard and then swap them for the user menu, which is
 * both a lie and a wider shift than it replaces.
 *
 * Neutral boxes at the resolved controls' heights, so nothing moves vertically
 * when the real thing lands. No pulse: the widths are a guess either way, and a
 * repainting animation costs more than it communicates.
 */
export function AuthedActionsPlaceholder() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="hidden items-center md:flex"><div className="h-[34px] w-24 rounded-(--r-full) bg-(--ink-10)" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<div className="flex items-center md:hidden"><div className="h-[38px] w-24 rounded-(--r-full) bg-(--ink-10)" /></div></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}